<header class="fm-admin-header" [class.fm-admin-header-scrolled]="isScrolled()">
  <div class="fm-admin-header-left">
    <!-- Desktop toggle: only shown when sidebar is collapsed -->
    @if (layoutService.isSidebarCollapsed()) {
      <button type="button" class="fm-admin-toggle" (click)="onToggle()" aria-label="Expand sidebar">
        <img class="fm-svg" src="images/icons/dashboard-icons/sidebar-toggle-rt.svg" alt="Expand" />
      </button>
    }
    <!-- Mobile toggle: always shown on small screens -->
    <button type="button" class="fm-admin-toggle d-xl-none" (click)="onMobileToggle()" aria-label="Open sidebar">
      <img class="fm-svg" src="images/icons/dashboard-icons/sidebar-toggle-rt.svg" alt="Menu" />
    </button>
    <!-- Mobile logo -->
    <div class="fm-admin-logo d-xl-none m-0">
      <a routerLink="/app/stories">
        <img class="fm-logo-image" src="images/logo-icon.svg" alt="Logo" />
      </a>
    </div>
    <!-- Search -->
    <div class="fm-searchbar d-none d-sm-block">
        <form (submit)="$event.preventDefault()">
        <div class="form-group">
          <input class="form-control" type="text" placeholder="Search anything..." aria-label="Search" />
        </div>
        <button class="fm-search-btn" type="submit">
          <img src="images/icons/fm-search-icon.svg" class="fm-svg" alt="Search Icon" />
        </button>
      </form>
    </div>
  </div>

  <div class="fm-admin-header-right">
    <button type="button" class="fm-admin-icon-btn" aria-label="Notifications">
      <img class="fm-svg" src="images/icons/fm-bell.svg" alt="Notifications" />
    </button>

    <div class="dropdown fm-user-dropdown">
      <a href="javascript:void(0);" class="fm-head-userprofile dropdown-toggle fm-dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        @if (profile()?.profileImagePath) {
          <img
            class="fm-profile"
            [src]="profile()!.profileImagePath"
            [alt]="profile()!.fullName"
            (error)="onAvatarError($event)"
          />
        } @else {
          <span class="fm-profile fm-profile-initials">
            {{ getInitials() }}
          </span>
        }
        <span class="fm-profile-content d-none d-sm-block">
          <span class="fm-profilename">{{ (profile()?.firstName && profile()?.lastName) ? (profile()!.firstName + ' ' + profile()!.lastName) : (profile()?.fullName || 'Account') }}</span>
          <span class="fm-emailinfo">{{ profile()?.email || '' }}</span>
        </span>
      </a>
      <div class="dropdown-menu dropdown-menu-end fm-dropdown-menu">
        <a routerLink="/app/settings" class="dropdown-item fm-dropdown-item">
          <span class="fm-icon"><img class="fm-svg" src="images/icons/fm-user-black.svg" alt="Profile" /></span>
          Profile
        </a>
        <div class="dropdown-divider fm-dropdown-divider my-1"></div>
        <button type="button" class="dropdown-item fm-dropdown-item fm-logout" (click)="openLogoutModal()">
          <span><img class="fm-svg" src="images/icons/fm-logout.svg" alt="Logout" /></span>
          Logout
        </button>
      </div>
    </div>
  </div>
</header>

<!-- Logout Confirmation Modal -->
@if (showLogoutModal()) {
  <div class="modal d-block fm-modal" tabindex="-1" role="dialog" (click)="onModalBackdropClick($event)">
    <div class="modal-dialog modal-dialog-centered fm-modal-dialog fm-logout-modal-dialog" role="document">
      <div class="modal-content fm-modal-content fm-logout-modal-content">

        <div class="fm-logout-modal-header">
          <button type="button" class="btn-close fm-logout-close" (click)="closeLogoutModal()" aria-label="Close"></button>
        </div>

        <div class="modal-body fm-modal-body fm-logout-modal-body">
          <div class="fm-logout-icon-wrap">
            <img src="images/icons/fm-logout.svg" alt="Logout" class="fm-svg fm-logout-icon" />
          </div>
          <h5 class="fm-head-28 mt-3 mb-2">Confirm Logout</h5>
          <p class="fm-logout-desc">Are you sure you want to log out of your account?</p>
          <div class="d-flex gap-3 justify-content-center mt-4">
            <button type="button" class="fm-common-btn fm-btn-outline" (click)="closeLogoutModal()">Cancel</button>
            <button type="button" class="fm-common-btn fm-btn-danger" (click)="confirmLogout()">
              <img src="images/icons/fm-logout.svg" alt="" class="fm-svg" style="width:16px;height:16px;filter:brightness(0) invert(1)" />
              Yes, Logout
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
}
